import { Tag as AntTag } from "antd";

const Tag = AntTag;

export default Tag;
